<div class="st-item-layout-toggle__trigger">
    <button
        #layoutMenuTrigger="matMenuTrigger"
        mat-icon-button
        st-click-stop-propagation
        st-space-stop-propagation
        st-enter-stop-propagation
        class="st-item-layout-toggle__btn"
        [matTooltip]="tooltip()"
        [matMenuTriggerFor]="layoutMenu"
        (menuOpened)="onMenuOpened()">
        <mat-icon fontSet="material-symbols-outlined">table_rows</mat-icon>
    </button>
    @if (showLabel()) {
        <span class="st-item-layout-toggle__btn-label">
            {{ isCondensed() ? languageSettings().PSTWebViewCondensedLabel : languageSettings().PSTWebViewCardLabel }}
        </span>
    }
</div>

<mat-menu
    #layoutMenu="matMenu"
    class="st-item-layout-toggle__menu"
    st-click-stop-propagation>
    <mat-selection-list
        #layoutSelectionList
        hideSingleSelectionIndicator
        class="st-item-layout-toggle__list"
        [multiple]="false"
        (selectionChange)="onSelectionChange($event)">
        <mat-list-option
            class="st-item-layout-toggle__option"
            st-click-stop-propagation
            [class.st-item-layout-toggle__option--selected]="!isCondensed()"
            [selected]="!isCondensed()"
            [value]="false">
            <mat-icon
                matListItemIcon
                class="st-item-layout-toggle__icon"
                fontSet="material-symbols-outlined">
                view_day
            </mat-icon>
            <div
                matListItemTitle
                class="st-item-layout-toggle__title">
                <span>{{ languageSettings().PSTWebViewCardLabel }} {{ languageSettings().PSTWebLayoutLabel }}</span>
                @if (!isCondensed()) {
                    <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
                }
            </div>
        </mat-list-option>
        <mat-list-option
            class="st-item-layout-toggle__option"
            st-click-stop-propagation
            [class.st-item-layout-toggle__option--selected]="isCondensed()"
            [selected]="isCondensed()"
            [value]="true">
            <mat-icon
                matListItemIcon
                class="st-item-layout-toggle__icon"
                fontSet="material-symbols-outlined">
                table_rows
            </mat-icon>
            <div
                matListItemTitle
                class="st-item-layout-toggle__title">
                <span>{{ languageSettings().PSTWebViewCondensedLabel }} {{ languageSettings().PSTWebLayoutLabel }}</span>
                @if (isCondensed()) {
                    <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
                }
            </div>
        </mat-list-option>
    </mat-selection-list>
</mat-menu>
